// index.js
import ImageViewerComponent from './ImageViewer'
const ImageViewer = {}
ImageViewer.install = Vue => {
    const ImageViewerConstructor = Vue.extend(ImageViewerComponent);
    const instance = new ImageViewerConstructor();
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
    //自定义拖动
    Vue.directive('drag', function(el, binding) {
        instance.isShowImageDialog = true;
        let oDiv = el; // 当前元素
        oDiv.addEventListener('touchstart', function(e) {
          e.preventDefault();
          let bw = document.body.clientWidth;
          let bh = document.body.clientHeight;
          // 触摸开始，计算当前元素距离可视区的距离
          let disX = e.touches[0].clientX - oDiv.offsetLeft;
          let disY = e.touches[0].clientY - oDiv.offsetTop;
          document.addEventListener('touchmove', onTouchMove);
          document.addEventListener('touchend', onTouchEnd);
          
          function onTouchMove(e) {
            // 通过事件委托，计算移动的距离
            let l = 0, t = 0;
            // 拖动边界
            if (e.touches[0].clientX >= bw) {
              l = bw - disX;
            } else if (e.touches[0].clientX <= 0) {
              l = 0 - disX;
            } else {
              l = e.touches[0].clientX - disX;
            }
            if (e.touches[0].clientY >= bh) {
              t = bh - disY;
            } else if (e.touches[0].clientY <= 0) {
              t = 0 - disY;
            } else {
              t = e.touches[0].clientY - disY;
            }
            // 移动当前元素
            oDiv.style.left = l + 'px';
            oDiv.style.top = t + 'px';
            // 将此时的位置传出去
            binding.value({ x: e.touches[0].pageX, y: e.touches[0].pageY });
          }
          
          function onTouchEnd(e) {
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
          }
        });
      });
    // 挂载触发方法
    Vue.prototype.$imageViewer = (images, index = 0) => {
        instance.images = Array.isArray(images) ? images : [images];
        instance.currentIndex = index;
        instance.currentImg = instance.images[index];
        instance.visible = true;
    }

    // 添加切换方法
    instance.nextImage = () => {
        instance.currentIndex = (instance.currentIndex + 1) % instance.images.length;
        instance.currentImg = instance.images[instance.currentIndex];
    }
    
    instance.prevImage = () => {
        instance.currentIndex = (instance.currentIndex - 1 + instance.images.length) % instance.images.length;
        instance.currentImg = instance.images[instance.currentIndex];
    }
}
export default ImageViewer;


// WEBPACK FOOTER //
// ./src/util/vue-imageViewer-master/index.js